import React, { Component } from 'react';
import { connect } from 'react-redux';
import { openLoginModal, openCartModal, openPriceGuideModal, openDeclineModal, closeModal } from '../modules/active_modal';
import { addProductToWishlist } from '../modules/wishlist_actions';
import { MAX_QUANTITY } from '../shared/cart';
import { setDeclineBook } from '../modules/decline_box_book';
import { addEnrollProductToCart, addProductToCart } from '../modules/cart_actions';
import EbookPurchase    from './EbookPurchase.jsx';
import PreorderPurchase from './PreorderPurchase.jsx';
import ProductDetailPreorderMessage from './ProductDetailPreorderMessage.jsx';
import LargePrintPurchase from './LargePrintPurchase.jsx';
import BlurayPurchase from './BlurayPurchase.jsx';

class ProductDetail extends Component {

  constructor(props) {
    super(props);
    let oProduct = props.modal && props.activeFeaturedSelection ? props.activeFeaturedSelection : props.activeProduct;
    let backorder_arrival_date = new Date(oProduct.backorder_arrival_date).getTime();
    this.deductFormat = this.deductFormat.bind(this);

    this.state = {
      productType : this.deductFormat(oProduct, props.store.tla),
      quantity: 1
    };

    this.toggleFormat = this.toggleFormat.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  deductFormat(oProduct, tla){
    if(oProduct.bluray) return 'bluray';
    else if( (tla === "DLP" || oProduct.visible === 0 ) && oProduct.large_print) return "large_print";
    else return 'regular';
  }

  componentWillReceiveProps(nextProps){
    if( nextProps.activeProduct !== this.props.activeProduct){
      this.setState({  productType: this.deductFormat(nextProps.activeProduct, nextProps.store.tla) });
      window.dataLayer.push({'event': 'viewproduct', 'mmid': nextProps.activeProduct.mmid, 'title': nextProps.activeProduct.title });
    }
    if( nextProps.activeFeaturedSelection && this.props.activeFeaturedSelection && nextProps.activeFeaturedSelection !== this.props.activeFeaturedSelection)
      this.setState({  productType: this.deductFormat(nextProps.activeFeaturedSelection, nextProps.store.tla) });
  }

  componentDidMount(){
    window.dataLayer.push({'event': 'viewproduct', 'mmid': this.props.activeProduct.mmid, 'title': this.props.activeProduct.title });
  }

  handleChange( event ) {
    this.setState({ quantity: parseInt( event.target.value ) });
  }

  writeHtmlFromString(string) {
    return {__html: string};
  }

  addToCartAction(oProduct) {
    let { store, featured, activeProduct, customer, upgradeStatus, isLoggedIn, dispatch, activeFeaturedSelection, activeModal, modal } = this.props;
    let cleanProduct = { ...oProduct, format: 'regular' };
    if(isLoggedIn && customer.status === 'Active' && !upgradeStatus ){
      if(store.type === "Neglite" || !featured.find( x => x.id === oProduct.id) || customer.current_cycle.response || !customer.current_cycle.active)
        dispatch( addProductToCart( cleanProduct, this.state.quantity ));
      else dispatch([
          setDeclineBook(cleanProduct, this.state.quantity),
          openDeclineModal(),
        ]);
    } else
      dispatch( modal && store.type === "Neglite" ?
        [addEnrollProductToCart( cleanProduct, this.state.quantity ), closeModal()] :
        addEnrollProductToCart( cleanProduct, this.state.quantity) );
  }

  renderAuthorList(authors){
    return authors.map((a, i) => {
      return <a href={"/catalog/author/"+a.id+"-"+a.url}>{a.name + (authors.length > 1 && i < authors.length - 1 ? ', ': '')}</a>
    });
  }

  toggleFormat(type){
    let { modal, activeProduct, activeFeaturedSelection } = this.props;
    let oProduct = modal && activeFeaturedSelection ? activeFeaturedSelection : activeProduct;
    this.setState({ productType: type});
  }

  render() {
    let { store, tla, activeFeaturedSelection, activeProduct, modal, path, cartItems, customer, upgradeStatus, isLoggedIn, featured } = this.props;
    // immediately return empty container if no activeProduct
    if (!activeProduct) {
      return <div className="content-max-width content-container" />
    }

    let {dispatch}          = this.props;
    let {productType } = this.state;
    let preAuthor           = store.tla === "DVD" ? "" : "by";
    let presales            = store.tla === "DVD" ? "Pre-orders" : "Presales";
    let publisherPrice      = store.tla === "DVD" ? "Studio Price" : "Publisher Price";
    let Book                = store.tla === "DVD" ? "" : "Book ";
    let Featured            = store.tla === "DVD" ? "Director's" : "Featured";
    let autoReminderCost    = store.tla === "DVD" ? 3 : 1;
    let oProduct            = modal && activeFeaturedSelection ? activeFeaturedSelection : activeProduct;
    let oProductWFormatData = productType === "regular" ? oProduct : {...oProduct, ...oProduct[productType], sale_price: oProduct[productType].price };
    let backorder_arrival_date = new Date( oProduct.backorder_arrival_date ).getTime();
    let pureEbook           = oProduct.ebook && !oProduct.large_print && oProduct.quantity_available === 0 && ( isNaN(backorder_arrival_date) || backorder_arrival_date > (Date.now() + ( 1000 * 60 * 60 * 24 * 14)) || backorder_arrival_date < Date.now() ) ? true : false;
    let sAuthor             = oProduct.authors ? this.renderAuthorList(oProduct.authors) : '';
    let sGenre              = oProduct.genres ? oProduct.genres.map((a) => a.name).filter(a => a).join(', ') : '';
    let isFeaturedSelection = (featured.find( f => f.id === oProduct.id && f.format === productType ));
    let fsMedalion          = isFeaturedSelection ? <img src={"/images/" + tla.toLowerCase() + "/fs-medallion.svg"} /> : '';
    let sImageSrc           = "//s3.amazonaws.com/bookspan-media/covers/full/" + oProductWFormatData.mmid + ".jpg";
    let ebookAvailable      = "";
    let wishlistAvailable   = "";
    let priceGuideAvailable = "";
    let autoShipReminder    = "";
    let oActionBox          = "";
    let oMsrp               = oProductWFormatData.msrp ? oProductWFormatData.msrp.toFixed(2) : 0.00;
    let oSalePrice          = oProductWFormatData.sale_price.toFixed(2);
    let oFormatButton       = <div />
    let purchaseButton      = cartItems.length > 0 && cartItems.filter( c => c && c.id == oProduct.id && c.format === 'regular' ).length >= 6 ? (
        <button
            className = "btn-primary disabled"
            name      = "book-added"
            disabled  = "true"
        >
          In Box
        </button>
    ) : (
      <button
        className = "btn-primary"
        name      = "book-added"
        onClick   = {this.addToCartAction.bind( this, { ...oProduct, format: 'regular'} )}
      >
        Add to Box
      </button>
    );
    sGenre       = (oProduct.genres) ? <li>{sGenre}</li> : '';
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    let prettyPubDate = monthNames[new Date(oProductWFormatData.available_date).getMonth()] + ' ' + new Date(oProductWFormatData.available_date).getDate() + ', ' + new Date(oProductWFormatData.available_date).getFullYear();
    let sPages   = (oProductWFormatData.pages)    ?  <tr><td className="detail">Pages:        </td><td>{oProductWFormatData.pages}</td></tr> : <tr><td className="collaspsed"></td></tr>;
    let sPubDate = (oProductWFormatData.available_date) ?  <tr><td className="detail">Release Date: </td><td className="no-wrap">{prettyPubDate}</td></tr> : <tr><td className="collaspsed"></td></tr>;
    let sIsbn    = (oProductWFormatData.isbn)     ?  <tr><td className="detail">ISBN:         </td><td>{oProductWFormatData.isbn}</td></tr> : <tr><td className="collaspsed"></td></tr>;
    let sClubId  = (oProductWFormatData.mmid)     ?  <tr><td className="detail">Club ID:      </td><td>{oProductWFormatData.mmid}</td></tr> : <tr><td className="collaspsed"></td></tr>;
    let sFormatText  = pureEbook ? "Ebook" : ( productType === "large_print" ? "Large Print" : "Regular Print");
    if(tla === "DVD") sFormatText = productType === "bluray" ? "Blu-ray" : "DVD";
    let sFormat  = <tr><td className="detail">Format:       </td><td>{sFormatText}</td></tr>;
    // Get and set number of days until release for presells
    let pubTime         = new Date(oProductWFormatData.available_date).getTime();
    // Get and set number of days until avaiable for bundle pricing
    const daysBack           = (24*60*60*1000) * 6; //6 days
    const bundleDate         = (pubTime - daysBack);
    const availableForBundle = monthNames[new Date(bundleDate).getMonth()] + ' ' + new Date(bundleDate).getDate();

    if(oProduct.ebook){
      if ( isLoggedIn && customer.status === 'Active' && !upgradeStatus )
        ebookAvailable = ( <EbookPurchase product = {oProduct} /> );
      else
        ebookAvailable =(
          <div className="message-box showing" >
            <h6>eBooks are for members only</h6>
            <p>To purchase the eBook of this title, please <a onClick={() => dispatch( openLoginModal() )}>log in</a> or <a onClick={() => dispatch( openCartModal() )}>join now</a>. </p>
          </div>
        );
    }

    if ( isLoggedIn && !upgradeStatus) {
      priceGuideAvailable = store.type === "Negative Option" ? "" : ( <a className="primary-color" onClick={() => dispatch( openPriceGuideModal() )}><em>Looking for our price guide?</em></a> );
      wishlistAvailable   = (
        <button
          className = "btn-tertiary wishlist"
          name      = "book-added"
          onClick   = {() => dispatch(addProductToWishlist({...oProductWFormatData, format: productType }) )} >
          <svg version="1.1" id="Layer_1" x="26px" y="12px" width="26px" height="12px" viewBox="0 0 19 19" >
          <path
            fill="#fff"
            d="M20.329,2.69c-3.74-5.717-9.189-0.535-9.724-0.054c-0.48-0.481-6.144-5.717-9.884,0.054
            c-3.633,5.556,7.533,14.425,9.67,15.226v0.054c0,0,0,0,0-0.054v0.054v-0.054C12.528,17.115,23.962,8.246,20.329,2.69z"
          />
      </svg>Save to Wishlist
        </button>
      );
    }

    // Featured Selections Auto Ship reminder for NegOp clubs
    if( isFeaturedSelection && store.type === "Negative Option" ) {
      autoShipReminder = (
        <div className="bordered-box reminder">
          <h3>Reminder!</h3>
          <p>If you do not accept or decline by the reply date, you will be automatically shipped a {Featured} Selection and charged ${autoReminderCost} more than the member price listed above.</p>
        </div>
      );
    }

    // pre order, can not purchase physical copy yet ( could also have ebook )
    if (!oProduct.bundle_pricing && !isFeaturedSelection ) {
      oActionBox = <PreorderPurchase
                    product = {oProduct}
                    productType={productType}
                    availableForBundle={availableForBundle}
                    toggleFormat={this.toggleFormat} />;
    // only ebook, no physical book
    } else if(pureEbook ) {
      oActionBox = (<div> <br /><br /></div>);
    } else {
      if(oProduct.large_print)
        purchaseButton = <LargePrintPurchase
                            product={oProduct}
                            quantity={this.state.quantity}
                            large_print={oProduct.large_print}
                            productType={productType}
                            toggleFormat={this.toggleFormat} />;
      else if (oProduct.bluray)
        purchaseButton = <BlurayPurchase
                            product={oProduct}
                            quantity={this.state.quantity}
                            bluray={oProduct.bluray}
                            productType={productType}
                            toggleFormat={this.toggleFormat} />;
      let quantitySelect = (store.bundle_pricing && isFeaturedSelection) ? (<div />) : (
        <div className="select-wrapper">
          <select onChange={this.handleChange.bind(this)} defaultValue="1">
           { new Array(MAX_QUANTITY).fill().map( (x, i) => (<option value={i+1}>{i+1}</option>)) }
          </select>
        </div>
      );

      let rightCol = (
         <div className="half-col">
            <h4 className="extra-spacing right">${oSalePrice}</h4>
            <h4 className="some-spacing primary-color right"><span><s>${oMsrp}</s></span></h4>
            {quantitySelect}
          </div>
      );

      if ( store.type === "Neglite" && oSalePrice <= store.credit_eligible )
        rightCol = (
          <div className="half-col">
            <h5 className="no-spacing primary-color right">1 Member Credit</h5>
            <h5 className="tiny-spacing right">or ${oSalePrice}</h5>
            <h5 className="some-spacing primary-color right"><span><s>${oMsrp}</s></span></h5>
            {quantitySelect}
          </div>
        );

      oActionBox = (
        <div className="bordered-box">
          <div className="half-col">
            <h5 className="alt left extra-spacing">Member Price:</h5>
            <h5 className="alt left extra-spacing">{publisherPrice}:</h5>
            {(store.bundle_pricing && isFeaturedSelection) ? (<div />) : (<h5 className="alt left extra-spacing">Quantity:</h5>)}
          </div>
          {rightCol}
          {purchaseButton}
        </div>
      );
    }

    oActionBox = (
      <div>
        {oActionBox}
        {ebookAvailable}
        {wishlistAvailable}
        {autoShipReminder}
      </div>
    );

    return (
      <div className="content-max-width content-container">
        <div className="wrapper-product-view">
          <div className="fs-medalion">{fsMedalion}</div>
          <div className="product-detail-container fs-detail">
            <div className="pd-image">
              <img src={sImageSrc} alt={oProduct.title} />
            </div>
            <div className="pd-details">
              <h2 className="primary-color">{oProductWFormatData.title}</h2>
              <h3>{oProduct.subtitle}</h3>
              <h4>{preAuthor} {sAuthor}</h4>
              <ul>
                {sGenre}
              </ul>
            </div>
            <div className="pd-actions">
              {oActionBox}
              <br />
              {priceGuideAvailable}
              <ProductDetailPreorderMessage
                oProduct={oProduct}
                isFeaturedSelection={isFeaturedSelection}
                availableForBundle={availableForBundle}
                prettyPubDate={prettyPubDate} />
            </div>
            <div className="pd-text" >
              <div dangerouslySetInnerHTML={this.writeHtmlFromString(oProduct.description)} />
              <div>
                <p><strong>Additional {Book}Details</strong></p>
                <table className="details">
                  <tbody>
                    {sPages}
                    {sPubDate}
                    {sIsbn}
                    {sClubId}
                    {sFormat}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'path': state.path,
      'tla': state.store.tla,
      'activeProduct': state.activeProduct,
      'activeModal': state.activeModal,
      'activeFeaturedSelection': state.activeFeaturedSelection,
      'featured' : state.featured,
      'customer': state.customer,
      'store': state.store,
      'isLoggedIn': state.isLoggedIn,
      'upgradeStatus': state.upgradeStatus,
      'cartItems' : state.computedCart.items
    };
}

export default connect(mapStateToProps)(ProductDetail);



// WEBPACK FOOTER //
// ./src/components/ProductDetail.jsx